import isGHMC, { getCurrentDate, getCurrentDateTime, getFirstDateOfMonth } from "../../../../Common/helper/helpar";
import { Formik, Form, Field } from "formik";
import { useMonthWiseAttendanceStore } from "../../Attendance/MonthWiseAttendanceSummary/MonthWiseAttendanceStore";
import { useEffect, useState } from "react";
import { GetCircle, GetZone } from "../../../../Apis/organizationApi";
import { GetOperations, GetDesignations } from "../../../../Apis/operationApi";
// import { MonthWiseAttendanceExport } from "./MonthWiseAttendanceExport";
import { getAllTransferStationMaster } from "../../../../Apis/transferStationApi";
import { TippingFeeExport } from "../TippingFeeCalculationReport/TippingFeeExport";
import { TonnageCompositionExport } from "./TonnageCompositionExport";

export const TonnageCompositionFilter = () => {
  const [allZones, setAllZones] = useState([]);
  const [allCircles, setAllCircles] = useState([]);
  const [allTransferStation, setAllTransferStation] = useState([]);
  const [allOperations, setAllOperations] = useState([]);
  const [allDesignation, setallDesignation] = useState([]);
  const [days, setDays] = useState([]);
  const isProd = isGHMC();
  const currentDate = getCurrentDate();
  const { MonthWiseAttendanceData, fetchMonthWiseAttendanceReport } =
    useMonthWiseAttendanceStore();
  const today = new Date();
  const fetchAllDataDetails = async () => {
    try {
      const transferStationData = await getAllTransferStationMaster()
      setAllTransferStation(transferStationData);
      const zonesData = await GetZone();
      setAllZones(zonesData);
      const circlesData = await GetCircle();
      setAllCircles(circlesData);
      const operationsData = await GetOperations();
      console.log("Fetched Operations Data:", operationsData); // Debugging step
      setAllOperations(Array.isArray(operationsData) ? operationsData : []);
      const designationsData = await GetDesignations();
      setallDesignation(
        Array.isArray(designationsData) ? designationsData : []
      );
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };
  useEffect(() => {
    if (MonthWiseAttendanceData[0]?.dayWiseAttendance) {
      const getMonth = JSON?.parse(
        MonthWiseAttendanceData[0]?.dayWiseAttendance
      );
      setDays(getMonth);
    } else {
      setDays([]);
    }
  }, [MonthWiseAttendanceData, MonthWiseAttendanceData[0]?.dayWiseAttendance]);

  const getLast30DaysDate = (day) => {
    const toDate = new Date(day);
    const thirtyDaysAgo = new Date(toDate.setDate(toDate.getDate() - 30));
    return thirtyDaysAgo.toISOString().split("T")[0]; // Format the date as YYYY-MM-DD
  };

  const initialFilterValues = {
    FromDate: getFirstDateOfMonth(),
    ToDate: currentDate,
    ZoneId: "",
    CircleId: "",
    EmployeeId: "",
    DesignationId: "",
    OperationId: "",
    EmployeeName: "",
  };

  const handleSubmit = (values) => {
    fetchMonthWiseAttendanceReport(values);
  };

  useEffect(() => {
    fetchAllDataDetails();
    fetchMonthWiseAttendanceReport(initialFilterValues);
  }, []);

  const handleReset = (resetForm) => {
    resetForm();
    fetchMonthWiseAttendanceReport(initialFilterValues);
  };

  return (
    <>
      <Formik initialValues={initialFilterValues} onSubmit={handleSubmit}>
        {({ values, setFieldValue, resetForm }) => (
          <Form>
              <div className="d-flex justify-content-between align-items-center mt-3">
              <div className="d-flex align-items-end gap-2 mb-2">
              <div style={{ width: "200px" }}>
                <div className="form-group-filter">
                  <label className="form-label w-100 text-left">
                    From Date
                  </label>
                  <Field
                    type="date"
                    id="FromDate"
                    value={values.FromDate}
                    name="FromDate"
                    className="form-control bg-white"
                    min={values.ToDate && getLast30DaysDate(values.ToDate)}
                    max={values.ToDate || currentDate}
                    required
                  />
                </div>
              </div>
              <div style={{ width: "200px" }}>
                <div className="form-group-filter">
                  <label className="form-label w-100 text-left">To Date</label>
                  <Field
                    type="date"
                    id="ToDate"
                    name="ToDate"
                    value={values.ToDate}
                    className="form-control bg-white"
                    max={currentDate}
                    required
                  />
                </div>
              </div>
              {/* <div className="col-md-3 d-flex gap-2 align-items-end "> */}
                <button
                  type="submit"
                  className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                >
                  Search
                </button>
                <button
                  type="reset"
                  className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                  onClick={() => handleReset(resetForm)}
                >
                  Reset
                </button>

               
              {/* </div> */}
            </div >
            <div className="mt-4 d-flex">
            <TonnageCompositionExport/>
            </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
